 import { initializeApp } from "firebase/app";
 import {
   getAuth,
   signInWithEmailAndPassword,
   signOut,
 } from "firebase/auth";
 import {
   getFirestore,
   getDocs,
   collection,
 } from "firebase/firestore";
 const firebaseConfig = {
    apiKey: "AIzaSyB-txtWPzPYmBylItEc9vcZRMh5oKWB-qc",
        authDomain: "iseatree-dev.firebaseapp.com",
        databaseURL: "https://iseatree-dev.firebaseio.com",
        projectId: "iseatree-dev",
        storageBucket: "iseatree-dev.appspot.com",
        messagingSenderId: "135495017909",
        appId: "1:135495017909:web:7ce3c041e73788b51ba5fc",
        measurementId: "G-RBG6WEH2VL"
 };
 const app = initializeApp(firebaseConfig);
 const auth = getAuth(app);
 const db = getFirestore(app);

 const logInWithEmailAndPasswordAndGetData = async (email, password) => {
   try {
     await signInWithEmailAndPassword(auth, email, password);
     console.log("logged in")
     const data = await fetchData();
    return data;
   } catch (err) {
     console.error(err);
     alert(err.message);
   }
 };

 const fetchData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "trees"));
      const newData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      return newData;
    } catch (err) {
      console.error(err);
      // Handle any error that occurs while fetching data
    }
  };
 
 const logout = () => {
   signOut(auth);
 };
 export {
   db,
   logInWithEmailAndPasswordAndGetData,
   logout,
 };